import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { locale as english } from './translate/en';
import { locale as danish } from './translate/ds';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';
import { NotificationsService } from 'angular2-notifications';
import { QualityTestService } from 'app/main/shared-component/quality-test/quality-test.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { OrderByStatus } from 'app/main/model/ProjectOffer';
import { OrderByFilterType } from 'app/main/model/ProjectOffer';
import { RequestForQualityTestImagesFilter } from 'app/main/model/RequestBase';
import * as moment from 'moment';
import { ProjectService } from 'app/main/pages/project/project.service';

@Component({
    selector: 'app-view-qualitytest-images',
    templateUrl: './view-qualitytest-images.component.html',
    styleUrls: ['./view-qualitytest-images.component.scss']
})
export class ViewQualityTestImagesComponent implements OnInit {
    qualityTestBeforeAfterImageList: any = [];
    showSpinner: boolean = false;
    moduleid: string = "";
    host: string;
    base64Image: any;
    searchValue: string = "";
    orderBy: string = 'Date DESC';
    sortStatus = OrderByStatus;
    requestModel: RequestForQualityTestImagesFilter = new RequestForQualityTestImagesFilter();

    searchStartDate: Date = new Date(moment().startOf('month').format('YYYY-MM-DD'));
    searchEndDate: Date = new Date(moment(new Date()).format("YYYY-MM-DD"));

    maxDate: Date = new Date();

    filterFolderType = OrderByFilterType;
    selectedFolderType: string = 'All';

    constructor(public dialog: MatDialog,
        private translationLoader: FuseTranslationLoaderService,
        private notificationsService: NotificationsService,
        private qualityTestService: QualityTestService,
        private translate: TranslateService,
        private projectService: ProjectService,
        private http: HttpClient) { this.translationLoader.loadTranslations(english, danish) }

    ngOnInit() {
        if (environment.url.endsWith("/"))
            this.host = environment.url.slice(0, -1);
        else
            this.host = environment.url;
        this.getQualityTestBeforeAfterImages();
    }

    getQualityTestBeforeAfterImages() {
        this.qualityTestBeforeAfterImageList = [];
        this.showSpinner = true;
        this.requestModel.orderBy = this.orderBy;
        this.requestModel.search = this.searchValue ? this.searchValue : "";

        this.requestModel.StartDate = moment(this.searchStartDate).format("YYYY-MM-DD");
        this.requestModel.EndDate = moment(this.searchEndDate).format("YYYY-MM-DD");
        this.requestModel.folderType = this.selectedFolderType;

        this.qualityTestService.GetOffersBeforeAndAfterImages(this.requestModel).subscribe({
            next: (response) => {
                this.showSpinner = false;
                if (response.result) {
                    this.qualityTestBeforeAfterImageList = response.result.allImageList;
                }
            },
            error: err => {
                this.showSpinner = false;
                this.translate.get("MESSAGES.DropBoxApiNotResponding").subscribe({
                    next: (res) => {
                        this.notificationsService.error(res);
                    },
                    error: err => {
                    }
                });
            }
        });
    }

    downloadImage(image) {
        var imageUrl = this.host + image.filePath;

        var model = {
            imagePath : image.filePath
        }
        this.projectService.DownloadImageByPath(model).subscribe({
            next: (res : any) => {
                const url = window.URL.createObjectURL(res);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'downloaded - ' + this.getFileNameWithExtension(model.imagePath);
                a.click();
                window.URL.revokeObjectURL(url);
            },
            error: err => {
                
            },        
        });
    }
    getFileNameWithExtension(filePath) {
        return filePath.split(/[/\\]/).pop();
    }
    search() {
        this.getQualityTestBeforeAfterImages();
    }

}
